import type { CSSProperties } from 'react';
import { mergeProps } from 'react-aria';
import { ProgressBar, type ProgressBarProps } from '@launchpad-ui/components';

import styles from './Spinner.module.css';

export type SpinnerProps = Omit<ProgressBarProps, 'isIndeterminate' | 'variant'> & {
  /** Animation start delay in milliseconds. Defaults to 500ms. */
  delay?: number;
};

export function Spinner({ 'aria-label': ariaLabel = 'loading', delay = 500, ...props }: SpinnerProps) {
  return (
    <ProgressBar
      {...mergeProps(
        {
          className: styles.Spinner,
          style: { '--spinner-delay': `${delay}ms` } as CSSProperties,
        },
        props,
      )}
      aria-label={ariaLabel}
      isIndeterminate
      variant="spinner"
    />
  );
}
